import categoryService from '@/services/category.service.ts';
import { filter } from 'lodash';
var state = {
    all: [],
    map: {},
    current: {},
};
var getters = {
    all: function (state) {
        return state.all;
    },
    allAvailable: function (state) {
        var filtered = filter(state.all, function (category) {
            return category.available();
        });
        return filtered;
    },
    hasCategories: function (state) {
        return (state.all.length > 0);
    },
    getCategory: function (state) { return function (id) {
        return state.map[id];
    }; },
    getName: function (state) { return function (id) {
        return state.map[id].name;
    }; },
    firstItem: function (state) { return function (id) {
        var category = state.map[id];
        return categoryService.firstItemInCategory(category);
    }; },
    section: function (state) { return function (id) {
        var category = state.map[id];
        return categoryService.sectionsInCategory(category);
    }; },
    categoryForItem: function (state) { return function (itemId) {
        var categories = state.all;
        return categoryService.getCategoryForItem(categories, itemId);
    }; },
    currentCategory: function (state) {
        return state.current;
    },
};
var actions = {
    fetchAll: function (_a) {
        var commit = _a.commit;
        if (state.all.length === 0) {
            return categoryService.fetchAll(function (menu) {
                // TODO this call should not come from all service
                commit('setCategories', menu.categories);
            });
        }
        return state.all;
    },
    setCategories: function (_a, categories) {
        var commit = _a.commit;
        commit('setCategories', categories);
    },
    setCurrentCategory: function (_a, category) {
        var commit = _a.commit;
        commit('setCurrentCategory', category);
    },
};
var mutations = {
    setCategories: function (state, categories) {
        state.all = categories;
        categories.forEach(function (category) {
            state.map[category.id] = category;
        });
    },
    setCurrentCategory: function (state, category) {
        state.current = category;
    },
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/category.store.ts
// module id = null
// module chunks = 